//main.js - VOTRE CODE ORIGINAL + OPTIMISATIONS MINIMALES
// Importation des modules nécessaires
import { createApp } from 'vue';
import App from './App.vue';
import i18n from './i18n'
// import { IonicVue } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

// Styles et icônes
import '@mdi/font/css/materialdesignicons.css';
// import '@ionic/core/css/ionic.bundle.css';
// import '@ionic/vue/css/core.css';
import 'vuetify/styles';

// Importation des librairies de gestion de l'état et de la navigation
import store from './store';
import router from "./router";

// Service worker et gestion des notifications
import './registerServiceWorker';
import "./messagingConfig";
// import { requestPermission } from "./messagingConfig";

// Firebase
import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, setLogLevel } from "firebase/firestore";
import firebaseConfig from "../firebaseConfig";
import { initializeAuth, indexedDBLocalPersistence } from 'firebase/auth';
// Google Analytics
import VueGtag from 'vue-gtag-next';

// Vuetify
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Initialisation de Firebase
const firebaseApp = initializeApp(firebaseConfig);

initializeAuth(firebaseApp, {
  persistence: indexedDBLocalPersistence,
});

// Réduction du niveau de log Firestore
setLogLevel("error"); // Réduit les logs Firestore aux erreurs critiques

let db;
try {
  db = initializeFirestore(firebaseApp, {
    experimentalForceLongPolling: true,
    useFetchStreams: false,
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (error) {
  console.error('❌ Erreur initialisation Firestore:', error);
}

// let db;
// try {
//   const isIOS = Capacitor.getPlatform() === 'ios';
  
//   db = initializeFirestore(firebaseApp, {
//     ...(isIOS ? {} : {
//       experimentalForceLongPolling: true,
//       useFetchStreams: false,
//     }),
//     localCache: persistentLocalCache({
//       tabManager: persistentMultipleTabManager(),
//     }),
//   });
// } catch (error) {
//   console.error('❌ Erreur initialisation Firestore:', error);
// }
  

// Initialisation de Vuetify
const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'dark',
    themes: {
      dark: {
        dark: true,
        colors: {
          // background: '#fbf5ef',
          background: '#000000',
          surface:'#000000'
          // background: '#F5F5F5',
        },
      },
    },
  },
   display: {
    mobileBreakpoint: 'sm', // Définit jusqu'à quelle taille l'écran est considéré comme mobile
  },
});

// Initialisation de l'application Vue
const vueApp = createApp(App);

// Ajout des plugins à l'application Vue
vueApp
  .use(i18n)
  .use(router) // Gestion de la navigation
  .use(store) // Gestion de l'état global
  .use(vuetify) // Framework UI (Vuetify)

  // .use(IonicVue) // Intégration d'Ionic
  .use(VueGtag, { property: { id: 'G-MTH7VM2WNG' } }); // Google Analytics

const initializeGoogleAuth = async () => {
  if (!Capacitor.isNativePlatform()) return; // 🔥 CORRECTION
  try {
    const { GoogleAuth } = await import('@codetrix-studio/capacitor-google-auth');
    await GoogleAuth.initialize({
      clientId: '514396492015-23ojjkf98574b1unv3dtclag01pc1m35.apps.googleusercontent.com',
      iosClientId: '514396492015-m12e388cse8ui9oaj14i1agqk44kls9g.apps.googleusercontent.com',
      scopes: ['profile', 'email'],
      grantOfflineAccess: true,
    });
  } catch (error) {
    //error
  }
};

// const initializeGoogleAuth = async () => {
//   if (Capacitor.getPlatform() !== 'android') return; // 🔥 FIX

//   try {
//     const { GoogleAuth } = await import('@codetrix-studio/capacitor-google-auth');

//     await GoogleAuth.initialize({
//       clientId: '514396492015-23ojjkf98574b1unv3dtclag01pc1m35.apps.googleusercontent.com',
//       iosClientId: '514396492015-m12e388cse8ui9oaj14i1agqk44kls9g.apps.googleusercontent.com',
//       scopes: ['profile', 'email'],
//       grantOfflineAccess: true,
//     });
//   } catch (error) {
//     // console.error('GoogleAuth init error:', error);
//   }
// };

// 🔥 CONFIGURATION GLOBALE DE LA STATUS BAR
const configureStatusBar = async () => {
  if (Capacitor.getPlatform() === 'android') {
    requestAnimationFrame(async () => {
      try {
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: '#000000' });
      } catch (e) {
        ////ok
      }
    });
  }
};


if (Capacitor.getPlatform() === 'ios') {
    document.documentElement.style.setProperty(
        '--safe-area-top', 
        `${window.screen.height - window.innerHeight > 20 ? 44 : 20}px`
    );
    document.documentElement.style.setProperty(
        '--safe-area-bottom', 
        `${window.screen.height - window.innerHeight > 20 ? 34 : 0}px`
    );
}

// ⚡ OPTIMISATION 1 : MONTER VUE EN PREMIER (avant Google Auth)
// Montage de l'application Vue IMMÉDIATEMENT
vueApp.mount('#app');
// console.log('✅ Vue monté en priorité');

// ⚡ OPTIMISATION 2 : SPLASH PLUS COURT + GOOGLE AUTH NON-BLOQUANT
(async () => {
  if (Capacitor.isNativePlatform()) {
    // 🔥 Configurer la StatusBar AVANT de cacher le splash
    await configureStatusBar();
    
    // Cacher le splash RAPIDEMENT (ne pas attendre Google Auth)
    setTimeout(() => {
      SplashScreen.hide();
      // console.log('✅ Splash caché en 2 secondes');
    }, 2000); // Réduit à 2 secondes

    // Google Auth en parallèle (non-bloquant)
    initializeGoogleAuth(); // PAS d'await = non-bloquant
  } else {
    // console.log('Application exécutée sur une plateforme non native');
  }
})();

// ⚡ OPTIMISATION 3 : SERVICE WORKER & NOTIFICATIONS EN DIFFÉRÉ
// setTimeout(() => {
//   if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
//     navigator.serviceWorker
//       .register('/firebase-messaging-sw.js')
//       .then((registration) => {
//         console.log('✅ Service Worker enregistré (différé):', registration);
//       })
//       .catch((error) => {
//         console.error('❌ Erreur Service Worker:', error);
//       });
//   }

//   requestPermission()
//     .then(() => console.log('✅ Notifications configurées (différé)'))
//     .catch(error => console.error('❌ Erreur notifications:', error));
// }, 3000);

// Service Worker uniquement (pas de permission)
setTimeout(() => {
  if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('✅ Service Worker enregistré (différé):', registration);
      })
      .catch((error) => {
        console.error('❌ Erreur Service Worker:', error);
      });
  }
}, 3000);

export { db };